import { useDispatch } from 'react-redux';

export default function useStoreVehicleInfo() {
    const dispatch = useDispatch();

    const executor = (vehicle_info) => {
        // Save to Redux
        dispatch({
            type: 'SET_VEHICLE_INFO',
            payload: vehicle_info,
        });

        // Save to localStorage to persist across page refreshes
        localStorage.setItem('vehicle_info', JSON.stringify(vehicle_info));
    };

    return executor;
};